
    const data = {"name":"src/core/icons/message-alert","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M13 11h-2V5h2m0 10h-2v-2h2m7-11H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            